module.exports = __webpack_public_path__ + "static/assets/2b82c459459bc946147d1a545bfd3de0.png";